export default __webpack_public_path__ + "static/assets/5aaceda728809a7e112cf968633e02a2.png";